let NODE_ENV = window.XINPOC_DISPATCH_CONFIG.isProject;
let title = {
  towway: "two way direct",
  HPYJ: "HPYJ แพลตฟอร์มการจัดส่ง",
  yuantong: "คอนโซลการจัดส่ง",
  chunsheng: "คอนโซลการจัดส่ง",
  TALK2ME: "แพลตฟอร์มเว็บดิสแพทเชอร์",
  wanlian: "เจ้าหน้าที่ควบคุมระบบอินเตอร์คอม CAC",
  EuroNews:"WOUXUN Global",
  quansheng:"QUESUM",
};
let voice_title = {
  XiamenGuanhe:"แพลตฟอร์มระบบอินเตอร์คอม บริการเฉพาะทาง ทำให้ระบบอินเตอร์คอมมีประสิทธิภาพยิ่งขึ้น",
  wanlian: "ความปลอดภัยของคุณ คือสิ่งที่เราให้ความสำคัญเป็นอย่างยิ่ง",
}
let conpanyname = {
  chunsheng:"Copyright © 2025 Poclink Radios. All Rights Reserved.",
  XiamenGuanhe:"Glohe Communication Technology(Xiamen) Co.,Ltd.",
  TALK2ME: "Talk2Me Social Inc. (832)880-0000",
  wanlian: "CONGO ASTRAL COMPANY",
  EuroNews: "WOUXUN COMMUNICATIONS LIMITED",
}

let versions = {
  EuroNews:'V1.00.00'
}

module.exports = {
  language: {
    name: 'ภาษาไทย',
    title: 'ภาษา',
  },

  about: {
    title: title[NODE_ENV] || 'คอนโซลควบคุมระบบอินเตอร์คอมทั่วโลก',
    conpanyname: conpanyname[NODE_ENV] || 'บริษัท เซินเจิ้น บอนาร์ด อินฟอร์เมชั่น เทคโนโลยี จำกัด',
    version:versions[NODE_ENV] || "v1.6.2"
  },
  login: {
    account: 'เข้าสู่บัญชีเข้าสู่ระบบของคุณ',
    password: 'กรอกรหัสผ่าน',
    installationServices: 'การติดตั้งบริการเสียง',
    rememberme: 'จำฉันไว้',
    Login: 'เข้าสู่ระบบ'
  },
  message: {
    loginAccountTips: 'บัญชีการเข้าสู่ระบบไม่สามารถว่างเปล่าได้',
    loginPasswordTips: 'รหัสผ่านไม่สามารถว่างเปล่าได้',
    usernamePasswordTips: 'บัญชีหรือรหัสผ่านไม่ถูกต้อง',
    loginsuccessful: 'เข้าสู่ระบบสำเร็จ',
    accountNumbers: 'หมายเลขบัญชีสามารถกรอกได้เฉพาะตัวเลขเท่านั้น!',
    noDispatcher: 'การเข้าสู่ระบบล้มเหลว บัญชีนี้ไม่ใช่ผู้จัดส่ง!',
    accountNotpresent: 'บัญชีนี้ไม่มีอยู่!',
    LoginAbnormal: 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ กรุณาลองอีกครั้ง!',
    voiceServiceNotInstalled: 'กรุณาติดตั้งบริการเสียง หากติดตั้งแล้ว กรุณารีเฟรชเบราว์เซอร์!',
    Videocallinprogress: 'วิดีโอคอลกำลังดำเนินการอยู่!',
    Voicecallinprogress: 'ในการโทรด้วยเสียง!',
    Youhavebeenclosedforspeaking: 'คุณถูกปิดระบบแล้ว!',
    tctemporarygroup: 'คุณแน่ใจว่าต้องการรีเฟรชและออกจากกลุ่มชั่วคราวหรือไม่',
    Doyouwanttologout: 'คุณต้องการออกจากระบบใช่ไหม?',
    prompt: 'คำใบ้',
    Nonetworklink: 'ไม่มีการเชื่อมต่อเครือข่าย',
    deletedGro: 'กลุ่มนี้ถูกลบไปแล้วและไม่สามารถดำเนินการได้!',
    Pleaseselectthedesired: 'กรุณาเลือกรายการที่ต้องการ',
    deletedGroUsers: 'ผู้ใช้งาน!',
    Voicecallfunction: 'กรุณาเปิดใช้งานฟังก์ชั่นการโทรด้วยเสียงในแพลตฟอร์มการจัดการก่อน!',
    Alreadytemporary: 'อยู่ในกลุ่มชั่วคราวแล้วโทรไม่ได้!',
    Onlysupports: 'รองรับการโทรออกเฉพาะผู้ใช้รายเดียวเท่านั้น!',
    Enablevoicecalls: 'ผู้ใช้นี้ไม่ได้เปิดใช้งานฟังก์ชั่นการโทรด้วยเสียงในแพลตฟอร์มการจัดการ!',
    Oncall: 'ไม่สามารถสร้างขณะกำลังโทรได้!',
    Shaketodeath: 'ไม่สามารถสร้างได้ขณะสั่น',
    Shaketodeath2: 'คุณไม่สามารถเปลี่ยนกลุ่มได้ในระหว่างการเขย่า',
    createregiongroups: 'คุณสามารถสร้างกลุ่มพื้นที่ได้สูงสุด 3 กลุ่มเท่านั้น!',
    temporarygroupsnoadd: 'อยู่ในกลุ่มชั่วคราวแล้ว สร้างไม่ได้!',
    haleDispatcherGroupUser: 'คุณสามารถบังคับสมาชิกในกลุ่มผู้จัดส่งได้เท่านั้น',
    TemporaryGroupNoHale: 'กลุ่มชั่วคราวไม่สามารถบังคับได้!',
    Groupcallfailure: 'การโทรแบบกลุ่มล้มเหลว',
    Exitsuccessfully: 'ออกสำเร็จแล้ว!',
    Usernotonline: 'ผู้ใช้ออฟไลน์!',
    Theotherpartyisbusy: 'อีกฝ่ายยุ่งอยู่!',
    Callfailed: 'โทรล้มเหลว!',
    Theotherpartyhashungup: 'อีกฝ่ายวางสายแล้ว!',
    Networkconnectionfailed: 'การเชื่อมต่อเครือข่ายล้มเหลว โปรดลองอีกครั้งในภายหลัง',
    Callended: 'สิ้นสุดการโทร!',
    Accountpassworderror: 'รหัสผ่านบัญชีไม่ถูกต้อง',
    Arrears: 'ค้างชำระ',
    Accountdoesnotexist: 'บัญชีไม่ได้มีอยู่',
    Permissionerror: 'ข้อผิดพลาดการอนุญาต',
    AccountInfoChange: 'ข้อมูลบัญชีได้รับการเปลี่ยนแปลง',
    Configuration: 'ข้อผิดพลาดข้อมูลการกำหนดค่า',
    accountOtherlogins: 'บัญชีนี้ถูกล็อกอินไปที่อื่นแล้ว!',
    Accountlogintimeout: 'การหมดเวลาการเข้าสู่ระบบบัญชี',
    Networkconnectionfailure: 'การเชื่อมต่อเครือข่ายล้มเหลว',
    Thenetworkisreconnecting: 'เครือข่ายกำลังเชื่อมต่อใหม่',
    Addinggroupfailed: 'ไม่สามารถเข้าร่วมกลุ่มได้',
    Addgrouprequesttimeout: 'การร้องขอเข้าร่วมกลุ่มหมดเวลาแล้ว',
    Singlecallfailure: 'การโทรครั้งเดียวล้มเหลว',
    Failedtojointhegroup: 'ไม่สามารถเข้าร่วมกลุ่มได้ [ข้อผิดพลาดการอนุญาต]',
    Failedtojointhegroup2: 'ไม่สามารถเข้าร่วมกลุ่มได้ [ไม่มีอยู่]',
    Failedtojointhegroup3: 'ไม่สามารถเข้าร่วมกลุ่มได้ [หมดอายุ]',
    Failedtojointhegroup4: 'ไม่สามารถเข้าร่วมกลุ่มได้ [จำกัดโควตา]',
    Failedtojointhegroup5: 'ไม่สามารถเข้าร่วมกลุ่มได้ [วัตถุที่ถูกต้องว่างเปล่า]',
    noSnatchingwheat: 'ห้ามจับไมค์หลายตัวในช่วงเวลาสั้นๆ',
    noRemoteclosureSnatchingwheat: 'สถานะปิดระยะไกลไม่อนุญาตให้จับไมโครโฟน',
    Failedtograbthewheat: 'ไม่สามารถใช้งานโฟกัสเสียงได้เมื่อจับไมโครโฟน',
    Grabbingwheattimeout: 'การรับสัญญาณการคว้าไมโครโฟนหมดเวลาตอบสนอง',
    Failedtoopenrecordingdevice: 'ไม่สามารถเปิดอุปกรณ์บันทึกได้',
    Accountlocked: 'บัญชีถูกล็อค',
    Terminallocked: 'เครื่องถูกล็อค',
    Machinecardlocked: 'การ์ดถูกล็อค',
    Noaccountinformationconfigured: 'ไม่มีข้อมูลบัญชีที่ได้รับการกำหนดค่า',
    Successfullysaved: 'บันทึกเรียบร้อยแล้ว!',
    Successfullysethost: 'ตั้งค่าโฮสต์สำเร็จแล้ว!',
    Successfullydeleted: 'ลบสำเร็จแล้ว!',
    Successfullyadded: 'เพิ่มเรียบร้อยแล้ว!',
    Successfullyremoved: 'ลบออกเรียบร้อยแล้ว!',
    update_successfully: 'อัปเดตสำเร็จ',
    Successfullymodified: 'การแก้ไขสำเร็จแล้ว!',
    oldpassworderror: 'รหัสผ่านเก่าผิด',
    Parametererror: 'ข้อผิดพลาดของพารามิเตอร์',
    Pleaseselecttheuseryouwanttoadd: 'กรุณาเลือกผู้ใช้ที่คุณต้องการเพิ่ม!',
    Addingfailed: 'เพิ่มไม่สำเร็จ รายชื่อผู้ใช้ไม่อยู่ในกลุ่มและว่างเปล่า!',
    Pleaseselectuserremoved: 'กรุณาเลือกผู้ใช้ที่คุณต้องการลบ!',
    Removalfailed: 'การลบล้มเหลวเมื่อรายชื่อผู้ใช้กลุ่มว่างเปล่า!',
    Prioritysetsuccessfully: 'การตั้งค่าลำดับความสำคัญสำเร็จแล้ว',
    Pleaseselectastartandendtime: 'กรุณาเลือกเวลาเริ่มต้นและเวลาสิ้นสุด',
    endTimeNoStarttime: 'เวลาสิ้นสุดไม่สามารถเร็วกว่าเวลาเริ่มต้นได้',
    Thestartandendtimesmustbeonthesameday: 'เวลาเริ่มต้นและเวลาสิ้นสุดจะต้องเป็นวันเดียวกัน',
    RedefineCustomization: 'หากพื้นที่ที่กำหนดเองมีน้อยกว่า 3 จุด กรุณาวาดใหม่!',
    Unabletocreatetemporarygroup: 'ไม่มีสมาชิกออนไลน์และไม่สามารถสร้างกลุ่มชั่วคราวได้!',
    Pleaseenteroldpassword: 'กรุณากรอกรหัสผ่านเก่าของคุณ',
    Pleaseenteranewpassword: 'กรุณากรอกรหัสผ่านใหม่',
    Confirmnewpassword: 'ยืนยันรหัสผ่านใหม่',
    noSamePassword: 'รหัสผ่านเก่าและรหัสผ่านใหม่ไม่สามารถเป็นรหัสเดียวกันได้!',
    noSamePasswordTow: 'รหัสผ่านที่คุณป้อนสองครั้งไม่ตรงกัน!',
    pleaseenterpasswordagain: 'กรุณากรอกรหัสผ่านอีกครั้ง',
    Successfullyprocessed: 'การประมวลผลความสำเร็จ',
    voice_title: voice_title[NODE_ENV] || ""
  },
  search: 'ค้นหา',
  users: 'ผู้ใช้',
  refund: 'กลับ',
  Loadingdesperately: 'กำลังโหลด',
  Speaking: 'การพูด...',
  Iamspeaking: 'ฉันกำลังพูดอยู่...',
  communicatebytelephone: 'เรียก',
  call: 'เรียก',
  hale: 'แรงดึงที่แข็งแกร่ง',
  Forceddemolition: 'การรื้อถอน',
  confirm: 'แน่นอน',
  cancel: 'ยกเลิก',
  dispatchIntercom: 'ระบบอินเตอร์คอมสำหรับรับ-ส่ง',
  allGroups: 'กลุ่มทั้งหมด',
  fixedGroup: 'กลุ่มคงที่',
  regionalGroup: 'กลุ่มภูมิภาค',
  filter: 'กรอง',
  all: 'ทั้งหมด',
  online: 'ออนไลน์',
  offline: 'ออฟไลน์',
  groupUser: 'กลุ่ม/ผู้ใช้',
  enter: 'เข้า',
  edit: 'แก้ไข',
  voiceIntercom: 'ระบบอินเตอร์คอมด้วยเสียง',
  baseStationSwitch: 'สวิตซ์สถานีฐาน',
  gpsSwitch: 'สวิตช์ GPS',
  viewHistoricalTrack: 'ดูร่องรอยทางประวัติศาสตร์',
  startingtime1: 'เวลาเริ่มต้น',
  selectionPeriod: 'เลือกเวลา',
  startingTime: 'เวลาเริ่มต้น',
  Pleaseselectadateandtime: 'กรุณาเลือกเวลาเริ่มต้น',
  EndTime: 'เวลาสิ้นสุด',
  Pleaseselectanendtime: 'กรุณาเลือกเวลาสิ้นสุด',
  selectDate: 'เลือกวันที่',
  SelectStartTime: 'เลือกเวลาเริ่มต้น',
  Now: 'ตอนนี้',
  Sure: 'แน่นอน',
  Closure: 'การปิด',
  editArea: 'ปรับเปลี่ยนภูมิภาค',
  deleteArea: 'ลบภูมิภาค',
  Areyousuretosavethefence: 'คุณแน่ใจว่าต้องการบันทึกรั้วหรือเปล่า?',
  deleteLocalgroup: 'คุณแน่ใจว่าต้องการลบกลุ่มโซนหรือไม่?',
  pleaseselectaregion: 'กรุณาเดินรอบบริเวณรั้วก่อน!',
  doubleclicktocreate: 'ดับเบิลคลิกเพื่อสร้าง',
  doubleclick: 'ดับเบิ้ลคลิก',
  Createregionalgroups: 'สร้างกลุ่มภูมิภาค',
  groupName: 'ชื่อกลุ่ม',
  Pleaseenterthegroupname: 'กรุณากรอกชื่อกลุ่ม',
  pleaseenteragroupname: 'กรุณากรอกชื่อกลุ่ม (2-15 หลัก ในภาษาจีนและภาษาอังกฤษ)',
  groupnameTips: 'ชื่อกลุ่มประกอบด้วยตัวเลข 2-15 หลักในภาษาจีนและภาษาอังกฤษ',
  pleaseenteragroupnameTips: 'ประกอบด้วยตัวเลข 2-15 หลักในภาษาจีนและภาษาอังกฤษ',
  selectGroup: 'เลือกกลุ่ม',
  Pinnedingroupusers: 'แก้ไขในกลุ่มผู้ใช้แล้ว',
  TemporaryGroup: 'ผู้ใช้กลุ่มชั่วคราว',
  Usernotingroup: 'ไม่ได้อยู่ในกลุ่มผู้ใช้',
  userImei: 'ผู้ใช้/IMEI',
  Pleaseselectauser: 'กรุณาเลือกผู้ใช้',
  Create: 'สร้าง',
  Cancel: 'ยกเลิก',
  groupEdit: 'การแก้ไขแบบกลุ่ม',
  usersingroup: 'ในกลุ่มผู้ใช้',
  UsernameImei: 'ชื่อผู้ใช้/IMEI',
  userName: 'ชื่อผู้ใช้',
  noData: 'ยังไม่มีข้อมูล',
  removeselectedusers: 'ลบผู้ใช้ที่เลือก',
  Removeall: 'ลบทั้งหมด',
  Addtheselecteduser: 'เพิ่มผู้ใช้ที่เลือก',
  Addall: 'เพิ่มทั้งหมด',
  Save: 'บันทึก',
  selectUser: 'เลือกผู้ใช้',
  Edittakeseffect: 'แก้ไขให้มีผล',
  UserManagement: 'การจัดการผู้ใช้',
  Userpriority: 'ความสำคัญของผู้ใช้',
  levelone: 'ระดับ 1',
  Secondary: 'ระดับ 2',
  Levelthree: 'ระดับ 3',
  Levelfour: 'ระดับ 4',
  Fifthgrade: 'ระดับ 5',
  Editstakeeffectimmediately: 'แก้ไขมีผลทันที',
  Setmoderator: 'ตั้งค่าโฮสต์',
  SelectHost: 'เลือกโฮสต์',
  Host: 'เจ้าภาพ',
  Pleasechoose: 'กรุณาเลือก',
  Deletemoderator: 'ลบโฮสต์',
  Setuphost: 'สามารถตั้งผู้ใช้เป็นโฮสต์ได้เพียงคนเดียวเท่านั้น',
  Pleaseselectacall: 'กรุณาเลือกเนื้อหาที่คุณต้องการพูดคุย',
  Waitingforanswering: 'รอให้อีกฝ่ายรับสาย',
  Inviteyoutovoicecall: 'เชิญคุณเข้าร่วมการโทรด้วยเสียง',
  callingusers: 'กรุณาเลือกผู้ใช้ที่คุณต้องการโทรหา',
  Forcedpullusers: 'กรุณาเลือกผู้ใช้ที่คุณต้องการดึง',
  Forceddismantlingusers: 'กรุณาเลือกผู้ใช้ที่ต้องการรื้อถอน',
  SearchLocation: 'ค้นหาตำแหน่งที่ตั้ง',
  Show: 'แสดง',
  Hide: 'ซ่อน',
  Default: 'ค่าเริ่มต้น',
  Satellite: 'ดาวเทียม',
  Roadconditions: 'สภาพถนน',
  Toolbox: 'กล่องเครื่องมือ',
  Ranging: 'การวัดระยะทาง',
  Mark: 'เครื่องหมาย',
  Broadcast: 'ออกอากาศ',
  EnableBroadcastGroup: 'กรุณาเปิดกลุ่มเพื่อรับการถ่ายทอดสดก่อน',
  textBroadcast: 'การออกอากาศข้อความ',
  Hasbeensent: 'ส่งแล้ว',
  textBroadcastContent: 'กรุณาระบุเนื้อหาข้อความออกอากาศ (ไม่เกิน 50 คำ)',
  pleaseentertextbroadcast: 'กรุณากรอกข้อความออกอากาศ',
  Send: 'ส่ง',
  voiceBroadcast: 'การออกอากาศด้วยเสียง',
  Clicktorecordvoicebroadcast: 'คลิกเพื่อบันทึกเสียงออกอากาศ',
  Pleaserecordthevoicebroadcast: 'กรุณาบันทึกเสียงออกอากาศ',
  RecordingTime: 'เวลาในการบันทึกต้องไม่น้อยกว่า 1 วินาที',
  Broadcaster: 'ผู้ประกาศข่าว',
  BroadcastTime: 'เวลาออกอากาศ',
  listento: 'ฟัง',
  Warningmessage: 'ข้อมูลคำเตือน',
  AlarmHistory: 'สำหรับข้อความเตือนเพิ่มเติมโปรดตรวจสอบประวัติ',
  Name: 'ชื่อ',
  Address: 'ที่อยู่',
  Time: 'เวลา',
  Check: 'ตรวจสอบ',
  State: 'สถานะ',
  Unprocessed: 'ไม่ผ่านการประมวลผล',
  DealWith: 'จัดการกับ',
  delete: 'ลบ',
  PTTbuttondisplay: 'จอแสดงผลปุ่ม PTT',
  SOSalarmsound: 'เสียงสัญญาณเตือนภัย SOS',
  Fencealarmsound: 'เสียงสัญญาณเตือนรั้ว',
  Motiontrajectorybinding: 'การเชื่อมโยงแทร็กการเคลื่อนไหว',
  Changepassword: 'เปลี่ยนรหัสผ่าน',
  Logoutoflogin: 'ออกจากระบบ',
  Dataanalysis: 'การวิเคราะห์ข้อมูล',
  Statisticstoday: 'สถิติของวันนี้',
  Currentonlineusers: 'จำนวนผู้ใช้งานออนไลน์ในปัจจุบัน',
  Totalnumberofusers: 'จำนวนผู้ใช้งานทั้งหมด',
  Fencerecord: 'บันทึกรั้ว',
  SOSrecord: 'บันทึก SOS',
  recordingrecord: 'การบันทึกเสียง',
  Grouponlineusers: 'กลุ่มผู้ใช้งานออนไลน์',
  Comparison: 'เปรียบเทียบจำนวนผู้ใช้งานออนไลน์ใน 7 วัน',
  warningcomparison: 'การเปรียบเทียบคำเตือน 30 วัน',
  Fencewarning: 'คำเตือนเรื่องรั้ว',
  SOSwarning: 'สัญญาณแจ้งขอความช่วยเหลือ',
  OldPassword: 'รหัสผ่านเก่า',
  NewPassword: 'รหัสผ่านใหม่',
  ConfirmPassword: 'ยืนยันรหัสผ่าน',
  consists: 'ประกอบด้วยตัวอักษรและตัวเลข 6 ถึง 16 ตัว',
  startingpoint: 'จุดเริ่มต้น',
  totallength: 'ความยาวรวม',
  ico: 'ไอคอน',
  date: 'วันที่',
  Targeting: 'วิธีการจัดวางตำแหน่ง',
  Basestationpositioning: 'การวางตำแหน่งสถานีฐาน',
  BeidouGPS: 'เป่ยโต่ว/GPS',
  direction: 'ทิศทาง',
  altitude: 'ระดับความสูง',
  Speed: 'ความเร็ว(กม./ชม.)',
  warmreminder: 'ข้อเตือนใจ: ข้อมูลมาจากบุคคลที่สามและอาจมีข้อผิดพลาด ดังนั้นจึงเป็นเพียงข้อมูลอ้างอิงเท่านั้น',
  Iconselection: 'การเลือกไอคอน',
  pleaseentername: 'กรุณากรอกชื่อ',
  changeicon: 'เปลี่ยนไอคอน',
  Universal: 'ทั่วไป',
  policesecurity: 'ความปลอดภัยตำรวจ',
  Firefighting: 'การดับเพลิง',
  Chemicalindustry: 'สารเคมี',
  other: 'อื่น',
  save: 'บันทึก',
  close: 'การปิด',
  viewtag: 'ดูแท็ก',
  addtag: 'เพิ่มแท็ก',
  Supportsaddingamaximum: 'รองรับการเพิ่มไอคอนสูงสุด 10 ไอคอน',
  Imageformaterror: 'ข้อผิดพลาดรูปแบบภาพ',
  uploadedimage: 'ขนาดภาพที่อัพโหลดต้องไม่เกิน 5kb!',
  uploadsuccessful: 'อัพโหลดสำเร็จแล้ว',
  uploadfailed: 'การอัพโหลดล้มเหลว',
  uploadfailedimage: 'การอัพโหลดล้มเหลว: ขนาดรูปภาพที่รองรับสูงสุดคือ 25×25 พิกเซล!',
  Successfuloperation: 'การดำเนินการสำเร็จ',
  operationfailed: 'การดำเนินการล้มเหลว',
  Editmark: 'แก้ไขแท็ก',
  Pleaseselecttheiconyouwanttodelete: 'กรุณาเลือกไอคอนที่คุณต้องการลบ',
  successfullydeleted: 'ลบสำเร็จแล้ว',
  failedtodelete: 'การลบล้มเหลว',
  north: 'ทิศเหนือ',
  South: 'ใต้',
  West: 'ตะวันตก',
  East: 'ทิศตะวันออก',
  truenorth: 'ทิศเหนือที่แท้จริง',
  duesouth: 'ไปทางทิศใต้',
  duewest: 'ตะวันตก',
  Zhengdong: 'เจิ้งตง',
  partial: 'อคติ',
  historyrecord: 'ประวัติศาสตร์',
  group: 'กลุ่ม',
  pleaseselectagroup: 'กรุณาเลือกกลุ่ม',
  sender: 'ผู้ส่ง',
  Pleaseselectuser: 'กรุณาเลือกผู้ใช้',
  Sendtime: 'ส่งเวลา',
  startrange: 'ช่วงเริ่มต้น',
  endrange: 'ช่วงท้าย',
  startdate: 'วันที่เริ่มต้น',
  Startingtime: 'เวลาเริ่มต้น',
  enddate: 'วันที่สิ้นสุด',
  to: 'ถึง',
  Clear: 'ชัดเจน',
  Confirm: 'แน่นอน',
  state: 'สถานะ',
  Pleaseselectastatus: 'กรุณาเลือกสถานะ',
  Processed: 'ดำเนินการแล้ว',
  Processor: 'ผู้จัดการ',
  processtime: 'ระยะเวลาในการประมวลผล',
  serialnumber: 'หมายเลขซีเรียล',
  operate: 'ดำเนินงาน',
  ViewSOSlocation: 'ดูตำแหน่ง SOS',
  Back: 'กลับ',
  Warmreminder: 'เคล็ดลับ: ข้อมูลจากบุคคลที่สามอาจมีข้อผิดพลาดและมีไว้สำหรับการอ้างอิงเท่านั้น',
  SOSalarmsintemporarygroupsarenotrecorded: 'สัญญาณเตือน SOS ในกลุ่มชั่วคราวจะไม่ถูกบันทึกไว้',
  Pleaseselectatype: 'กรุณาเลือกประเภท',
  deleted: 'ลบแล้ว',
  next: 'ต่อไป',
  Tobeprocessed: 'รอดำเนินการ',
  dealwith: 'จัดการกับ',
  alreadydispatched: 'ส่งเรียบร้อยแล้ว',
  temporarygroup: 'กลุ่มชั่วคราว',
  NortheasternHemisphere: 'ซีกโลกตะวันออกเฉียงเหนือ',
  northwesternhemisphere: 'ซีกโลกตะวันตกเฉียงเหนือ',
  SoutheasternHemisphere: 'ซีกโลกตะวันออกเฉียงใต้',
  southwesternhemisphere: 'ซีกโลกตะวันตกเฉียงใต้',
  Nolocationtrack: 'ไม่มีการติดตามตำแหน่ง',
  Latitudeandlongitude: 'ละติจูดและลองจิจูด',
  Reportingtime: 'การรายงานเวลา',
  Positioningtime: 'การวางตำแหน่งเวลา',
  Alarminformation: 'ข้อมูลคำเตือน',
  AlarminformationTips: 'สำหรับข้อความเตือนเพิ่มเติมโปรดตรวจสอบประวัติ',
  initiatesos: 'เริ่มต้น SOS',
  Forcedvideo: 'วิดีโอแรงดึงสูง',
  videocall: 'วีดีโอคอล',
  Videopostback: 'อัพโหลดวิดีโอ',
  leave: 'ออกจาก',
  Enter: 'เข้า',
  fence: 'รั้ว',
  newgroup: 'สร้างกลุ่มใหม่',
  Joingroup: 'เข้าร่วมกลุ่ม',
  Thegroupnamealreadyexistspleasereenterit: 'ชื่อกลุ่มมีอยู่แล้ว กรุณากรอกใหม่อีกครั้ง',
  Groupcreatedsuccessfully: 'สร้างกลุ่มสำเร็จแล้ว',
  Groupcreationfailedpleasecreateagain: 'การสร้างกลุ่มล้มเหลว กรุณาสร้างใหม่อีกครั้ง!',
  Pleaseenterthegrouppassword: 'กรุณากรอกรหัสผ่านกลุ่ม',
  Thegrouppasswordyouenterediswrong: 'รหัสผ่านกลุ่มที่คุณป้อนไม่ถูกต้อง',
  Grouppassword: 'รหัสผ่านกลุ่ม',
  Dissolve: 'ยุบวง',
  Exit: 'ล้มเลิก',
  Disbandselforganizedgroup: 'การยุบกลุ่มที่สร้างขึ้นเอง',
  Exittheselfcreatedgroup: 'ออกจากกลุ่มที่สร้างด้วยตนเอง',
  ExiDissolvetheselfestablishedgroupt: 'คุณแน่ใจหรือไม่ว่าต้องการยุบกลุ่มที่คุณสร้างขึ้นเอง?',
  Exitselfbuiltgroup: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากกลุ่มที่สร้างขึ้นเองนี้?',
  Grouptransfer: 'การโอนกรรมสิทธิ์กลุ่ม',
  Theusersselfbuiltgroupfunctionisnotopened: "ฟังก์ชันกลุ่มที่ผู้ใช้สร้างไม่ได้เปิดใช้งาน",
  Createfence: 'สร้างรั้ว',
  Editfence: 'แก้ไขรั้ว',
  electricfence: 'รั้วไฟฟ้า',
  Electronicfencelist: 'รายการรั้วไฟฟ้า',
  fencename: 'ชื่อรั้ว',
  efficient: 'มีประสิทธิภาพ',
  Invalid: 'การทำให้เป็นโมฆะ',
  Forbidden: 'ห้าม',
  Noentry: 'ห้ามเข้า',
  Pleasesearchorselfselectthefencedareafirst: 'กรุณาเดินรอบบริเวณรั้วก่อน!',
  Areyousureyouwanttodeletetheelectronicfence: 'คุณแน่ใจว่าต้องการลบรั้วภูมิศาสตร์หรือไม่?',
  Triggermode: 'วิธีการทริกเกอร์',
  timesetting: 'การตั้งเวลา',
  Pleaseenterthefencename: 'กรุณากรอกชื่อรั้ว',
  tipsItconsists: 'ประกอบไปด้วยอักขระจีน ตัวเลข ตัวอักษร และเครื่องหมายขีดล่าง จำนวน 1-15 ตัว และไม่สามารถเริ่มต้นด้วยเครื่องหมายขีดล่างได้',
  tipsItconsistsName: 'ชื่อรั้วประกอบด้วยอักขระจีน ตัวเลข ตัวอักษร และเครื่องหมายขีดล่าง 1-15 ตัว และไม่สามารถเริ่มต้นด้วยเครื่องหมายขีดล่างได้',
  Pleaseselectamethodofentryandexit: 'กรุณาเลือกวิธีเข้าและออกของคุณ!',
  Pleaseselectatleastoneday: 'กรุณาเลือกอย่างน้อย 1 วัน',
  Notinfenceusers: 'ผู้ใช้ที่ไม่ถูกล้อมรั้ว',
  Usersonthefence: 'ในรั้วผู้ใช้',
  Validdate: 'วันที่เริ่มใช้บังคับ',
  Validperiod: 'ระยะเวลาใช้งาน',
  Selecttimerange: 'เลือกช่วงเวลา',
  Monday: 'ในวันจันทร์',
  Tuesday: 'วันอังคาร',
  Wednesday: 'วันพุธ',
  Thursday: 'วันพฤหัสบดี',
  Friday: 'วันศุกร์',
  Saturday: 'วันเสาร์',
  Sunday: 'วันอาทิตย์',
  Createdsuccessfully: 'สร้างความสำเร็จ',
  Thefencenameisduplicated: 'ชื่อรั้วซ้ำ กรุณาแก้ไขและลองใหม่อีกครั้ง',
  Ifnotselected: 'อย่าเลือกเอฟเฟกต์ถาวรที่เป็นค่าเริ่มต้น',
  FenceEdit: 'รั้วแก้ไข',
  Removalfailedfence: 'การลบล้มเหลว รายชื่อผู้ใช้รั้วว่างเปล่า!',
  Failedtoaddfence: 'เพิ่มไม่สำเร็จ รายชื่อผู้ใช้ว่างเปล่า!',
  Outofboundsrecord: 'บันทึกข้ามพรมแดน',
  Outofboundstype: 'ประเภทนอกขอบเขต',
  Pleaseselectausername: 'กรุณาเลือกชื่อผู้ใช้',
  Pleaseselecttriggermethod: 'กรุณาเลือกวิธีการทริกเกอร์',
  Crossborderdate: 'วันที่ข้ามพรมแดน',
  currentrecord: 'บันทึกปัจจุบัน',
  Triggertime: 'เวลาทริกเกอร์',
  Pleaseselectafencename: 'กรุณาเลือกชื่อรั้ว',
  Releasetime: 'เวลาปล่อยตัว',
  Batchdownload: 'ดาวน์โหลดแบบแบตช์',
  Recordingplayback: 'การบันทึกการเล่น',
  download: 'ดาวน์โหลด',
  Areyousureyouwant: 'คุณแน่ใจหรือไม่ว่าต้องการดาวน์โหลดการบันทึกที่เลือก?',
  Record: 'บันทึก',
  Pleaseselecttherecording: 'กรุณาเลือกการบันทึกที่คุณต้องการดาวน์โหลด',
  downloadsuccessful: 'ดาวน์โหลดสำเร็จ',
  Voiceaudio: 'เสียง เสียง',
  text: 'ข้อความ',
  voice: 'เสียง',
  Doubleclicktocreate: 'ดับเบิลคลิกเพื่อสร้าง',
  Doubleclicktosave: 'ดับเบิลคลิกเพื่อบันทึก',
  outofboundsperson: 'คนข้ามพรมแดน',
  temporarygroupTow: 'กลุ่มชั่วคราว',
  Theotherpartyhasnoanswer: 'ไม่มีการตอบสนองจากอีกฝ่าย!',
  sosrecord: 'ประวัติ SOS',
  UnhandledSOSexists: 'มี SOS ที่ยังไม่ได้ประมวลผล',

  RealTimeVideo: 'วิดีโอแบบเรียลไทม์',
  ForceVideo: 'บังคับวิดีโอ/การส่งวิดีโอ',
  VideoCall: 'วิดีโอคอล',
  CurrentlyNoRealTimeVideo: 'ขณะนี้ไม่มีวิดีโอแบบเรียลไทม์',
  VideoUserList: 'รายชื่อผู้ใช้วิดีโอ',
  Filter: 'ตัวกรอง:',
  All: 'ทั้งหมด',
  Online: 'ออนไลน์',
  Offline: 'ออฟไลน์',
  GroupUser: 'กลุ่ม/ผู้ใช้',
  ForceVideos: 'บังคับวิดีโอ',
  PleaseSelectTheUserWhoNeedsxxx: 'โปรดเลือกผู้ใช้！',
  TheDispatcherCannotForceIt: 'ผู้ควบคุมไม่สามารถบังคับได้!',
  VoiceCallInProgress: 'กำลังโทรออกด้วยเสียง!',
  PleaseActivateTheVideoServiceAndVideoCallFunctionOnTheManagementPlatformFirst: 'กรุณาเปิดใช้งานบริการวิดีโอและฟังก์ชันวิดีโอคอลบนแพลตฟอร์มการจัดการก่อน!',
  PleaseEnableTheVideoCallFunctionOnTheManagementPlatformFirst: 'กรุณาเปิดใช้งานฟังก์ชันวิดีโอคอลบนแพลตฟอร์มการจัดการก่อน!',
  UserIsNotOnline: 'ผู้ใช้ไม่ออนไลน์',
  OnlySupportsInitiatingVideoCallsToASingleUser: 'รองรับการเริ่มวิดีโอคอลกับผู้ใช้รายเดียวเท่านั้น',
  ThisUserHasNotActivatedTheVideoServiceOnTheManagementPlatform: 'ผู้ใช้รายนี้ยังไม่ได้เปิดใช้งานบริการวิดีโอบนแพลตฟอร์มการจัดการ!',
  ThisUserHasNotEnabledTheVideoCallFunctionOnTheManagementPlatform: 'ผู้ใช้รายนี้ยังไม่ได้เปิดใช้งานฟังก์ชันวิดีโอคอลบนแพลตฟอร์มการจัดการ!',
  VideoCallInProgress: 'วิดีโอคอลกำลังดำเนินการอยู่!',
  CannotCallTheTerminalThatIsTransmittingVideo: 'ไม่สามารถโทรไปยังเทอร์มินัลที่กำลังส่งวิดีโอได้',
  TheOtherPartyIsBusy1: 'อีกฝ่ายไม่ว่าง',
  ThisUserHasNotEnabledTheForceVideoFunctionOnTheManagementPlatform: 'ผู้ใช้รายนี้ยังไม่ได้เปิดใช้งานฟังก์ชันวิดีโอคอลบนแพลตฟอร์มการจัดการ!',
  CannotForceTheTerminalThatIsTransmittingVideo: 'ไม่สามารถบังคับเทอร์มินัลที่กำลังส่งวิดีโอได้',
  UserAlreadyExists: 'ผู้ใช้มีอยู่แล้ว',

  TheOtherPartyInvitedMeToAVideoCall: 'อีกฝ่ายชวนคุณวิดีโอคอล...',
  Connecting: 'กำลังเชื่อมต่อ...',
  TheOtherPartyHasRejected: 'อีกฝ่ายได้ปฏิเสธ',
  TheOtherPartyHasHungUp: 'อีกฝ่ายวางสายไปแล้ว',
  TheOtherPartyDidNotAnswer: 'ผู้โทรไม่รับสาย',
  TheOtherPartyIsBusy2: 'อีกฝ่ายยุ่งอยู่!',
  ConnectionInterruptedCallEnded: 'การเชื่อมต่อถูกตัดการโทรออก!',
  AnswerFailed: 'คำตอบล้มเหลว',
  ConnectionFailed: 'การเชื่อมต่อล้มเหลว',
  exceedFenceMsg:'จำนวนการสร้างเกินขีดจำกัดแล้ว กรุณาลบรั้วแล้วลองใหม่อีกครั้ง!',

  userPatrol: {
    searchLable: {
        PlanName: "ชื่อโครงการ",
        PatrolUsers: "ผู้ใช้บริการสายตรวจ",
        ExecutionResult: "ผลการดำเนินการ",
        PatrolTime: "เวลาลาดตระเวน",
        PatrolPointName: "ชื่อจุดลาดตระเวน",
    },
    placeholder: {
        PleaseEnterThePlanMame: "กรุณาระบุชื่อแผน",
        PleaseEnterThePatrolUser: "กรุณากรอกชื่อผู้ใช้งานสายตรวจ",
        PleaseSelectTheExecutionResult: "กรุณาเลือกผลลัพธ์การดำเนินการ",
    },
    tableHeader:{
        PlanName: "ชื่อโครงการ",
        patrolPoint: "จุดลาดตระเวน",
        PatrolUsers: "ผู้ใช้บริการสายตรวจ",
        PatrolPointName:"ชื่อจุดลาดตระเวน",
        StartTime: "เวลาเริ่มต้น",
        EndTime: "เวลาสิ้นสุด",
        ExecutionResult: "ผลการดำเนินการ",
        type:"พิมพ์",
        PatrolTime:"เวลาลาดตระเวน",
    },
    status: {
        NotStarted:"ยังไม่ได้เริ่มต้น",
        InProgress: "กำลังดำเนินการอยู่",
        Completed: "สมบูรณ์",
        MissingPatrol: "การตรวจสอบที่พลาด",
        positioning: "ตำแหน่ง",
        NFC:"เอ็นเอฟซี",
        Bluetooth: "บลูทูธ",
    },
    StartingRange: "ช่วงเริ่มต้น",
    EndRange: "ช่วงปลาย",
    ViewDetails:"ตรวจสอบรายละเอียด",
    PatrolTrajectory: "เส้นทางลาดตระเวน",
    patrol:'ลาดตระเวน',
    PatrolFailed:"การลาดตระเวนล้มเหลว",
    PatrolLog: "บันทึกการลาดตระเวน",
  }
};